export default class SectionIcon {
  constructor(name, isActive) {
    this.name = name;
    this.isActive = isActive;
  }
}
